import * as React from "react";
import { Leaf, BadgeDollarSign, MapPin, ArrowRight } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
const features = [{
  title: "Simplicity",
  description: "We strip away the complexity of smart tech, leaving only intuitive controls that feel like second nature.",
  icon: Leaf,
  iconColor: "text-primary",
  link: "/MozaMethodPage",
  number: "01"
}, {
  title: "Privacy",
  description: "Your home is your sanctuary. We exclusively use HomeKit to ensure your data never leaves your four walls.",
  icon: BadgeDollarSign,
  iconColor: "text-primary",
  link: "/MozaMethodPage",
  number: "02"
}, {
  title: "Elegance",
  description: "Technology should be felt, not seen. We integrate automation that complements your home's aesthetic.",
  icon: MapPin,
  iconColor: "text-primary",
  link: "/MozaMethodPage",
  number: "03"
}];
export default function TheJunkDaddyDifference() {
  return <section data-section-id="225002" id="our-core-values" className="dark bg-background py-20 md:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 text-center md:mb-16">
          <h2 className="font-default text-3xl font-bold tracking-tighter text-foreground md:text-4xl lg:text-5xl">
            The Art of Simple Living
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-lg text-muted-foreground font-default">
            Moza Casa is built on three foundational pillars that redefine how you interact with your living space.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {features.map((feature, i) => <div data-index={i} key={i} className="group relative h-full">
              <Link to={feature.link} className="absolute inset-0 z-10">
                <span className="sr-only">Learn more about {feature.title}</span>
              </Link>
              <Card className="flex h-full flex-col justify-between rounded-none border-none bg-transparent shadow-none transition-all duration-500 group-hover:bg-accent/10">
                <div>
                  <CardHeader className="pb-4">
                    <div className="mb-4 font-default text-6xl font-bold text-primary/20 transition-colors duration-500 group-hover:text-chart-2">
                      {feature.number}
                    </div>
                    <CardTitle className="font-default text-2xl font-bold tracking-tight text-foreground">
                      {feature.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <CardDescription className="text-base leading-relaxed text-muted-foreground font-default">
                      {feature.description}
                    </CardDescription>
                  </CardContent>
                </div>
                <div className="px-6 pb-6">
                  <div className="flex items-center text-xs font-bold uppercase tracking-widest text-chart-2 opacity-0 transition-all duration-500 group-hover:translate-x-2 group-hover:opacity-100">
                    Explore Philosophy <ArrowRight className="ml-2 size-4 stroke-[2]" />
                  </div>
                </div>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}